import {
  Component,
  HostBinding,
  Input,
} from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "umss-label",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.scss"],
})
export class UmssLabelComponent {
  @HostBinding("style.display") display = "contents";

  constructor() { }

  /** Content props */
  @Input() text: string = "Label"; // Label text content
  @Input() htmlFor?: string; // Associates label with form control (for attribute)

  /** Variant props - Well-typed and comprehensive */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular'; // Size variant
  @Input() layout: 'Block' | 'Inline' = 'Block'; // Layout variant
  @Input() weight: 'Normal' | 'Medium' | 'Semibold' = 'Medium'; // Font weight

  /** State props */
  @Input() required: boolean = false; // Shows required indicator
  @Input() disabled: boolean = false; // Disabled state styling
  @Input() error: boolean = false; // Error state styling

  /** Computed properties for accessibility */
  get computedClasses(): string[] {
    const classes = ['label'];
    
    if (this.required) classes.push('required');
    if (this.disabled) classes.push('disabled');
    if (this.error) classes.push('error');
    
    return classes;
  }
}
